import type { StoreActionApi } from 'react-sweet-state';
import type { Message } from '../../../common/types';

import type { State } from '../types';

export const setConversationId =
    (conversationId: string) =>
    ({ setState }: StoreActionApi<State>) => {
        setState({ conversationId });
    };

export const addVirtualAgentMessage =
    (message: Message) =>
    ({ getState, setState }: StoreActionApi<State>) => {
        const { messages } = getState();

        setState({
            messages: [...(messages || []), message],
        });
    };

export const setVirtualAgentLoading =
    (isLoading: boolean) =>
    ({ setState }: StoreActionApi<State>) => {
        setState({ isLoading });
    };
